export const capitalise = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitaliseAllWords = (str: string): string => {
  return str.split(" ").map(capitalise).join(" ");
};
